import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'
import { SettingsModal } from './SettingsModal'

/**
 * Single gated mount point for the settings-revamp modal. Mounted once near the dashboard root.
 * Renders nothing until the SETTINGS_REVAMP_FOUNDATION flag resolves on, so flag-off users keep the
 * legacy settings/account pages untouched.
 */
export function SettingsModalRoot() {
  const { enabled, loading } = useRuntimeFeatureFlag(RuntimeFeatureFlag.SETTINGS_REVAMP_FOUNDATION)
  if (!enabled || loading) return null
  return <SettingsModal />
}
